import React, { Component } from "react";
import { connect } from "react-redux";
import "react-bootstrap";

import adsApi from "../../api/adsApi";
import store from "../../store/configureStore";
import * as apiConstant from "../../api/apiConstant";
import { addNotification } from "../../actions/notificationAction";
import { lang } from "../../config/lang";
import logApi from "../../api/logApi";
class Ads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adsInfo: {},
    };
    this.getAdsInfo = this.getAdsInfo.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    sessionStorage.setItem("isInited", "Y");
    this.getAdsInfo();
  }

  componentWillUnmount() {}

  componentDidUpdate() {}

  componentWillReceiveProps(newProps) {
    this.getAdsInfo();
  }

  getAdsInfo() {
    adsApi.getAdsInfo().then((json) => {
      if (json.status === 200) {
        if (json.data.file_path !== undefined && json.data.file_path !== null) {
          this.setState({
            adsInfo: json.data,
          });
          // console.log('------- ', json.data)
          window.openHomeADS();
        }
      } else {
        store.dispatch(addNotification(`${lang("server_err")}`, "error"));
      }
    });
  }

  render() {
    if (
      this.state.adsInfo.file_path === undefined ||
      this.state.adsInfo.file_path === null
    ) {
      return <div></div>;
    }

    return (
      <div data-lightbox="home-ads">
        <a
          id="home_ads"
          data-lightbox="home-ads-item"
          href={`${apiConstant.homeAdsURL(this.state.adsInfo.file_path)}`}
          className={
            "icon d-flex justify-content-center align-items-center image-popup"
          }
          onClick={() =>
            logApi.log({
              title: this.props.title,
              lang: this.props.language,
              type: "사진",
            })
          }
        ></a>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(Ads);
